<div class="userQrCode-container" *ngIf="barCodeValue || qrCodeValue"
  [ngStyle]="{ 'gap': qrbarcodegap? qrbarcodegap : '20px'}">
  <h1 *ngIf="isShowDesc">{{'show.code.to.cashier' | translate}}</h1>

  <div class="userBarQRCode" (click)="showBarCodeDialog()" *ngIf="barCodeValue">
    <ejs-barcodegenerator #barcode id="barcode" width="{{barCodeWidth ?? '272px'}}" height="{{barCodeHeight ?? '80px'}}"
      mode="SVG" value="{{barCodeValue}}"></ejs-barcodegenerator>
  </div>

  <h1 *ngIf="isShowDesc">{{'tap.to.zoom.qrbarcode' | translate}}</h1>

  <div class="userBarQRCode" (click)="showQRDialog()" *ngIf="qrCodeValue">
    <ejs-qrcodegenerator #barcode id="barcode" width="{{QrWidth ?? '160px'}}" height="{{QrHeight ?? '160px'}}"
      mode="SVG" value="{{qrCodeValue}}"></ejs-qrcodegenerator>
  </div>
</div>